import React, { Component } from 'react';
import classNames from 'classnames';
import ProductComponent, {
  TParentComponentProps,
} from '@views/components/common/ParentComponent';
import ListInlineItem from './ListInlineItem';
import ListInlineLink from './ListInlineLink';

export type TListInlineProps = TParentComponentProps & {
  filteredCategory?: boolean;
  filterList?: boolean;
};

export class ListInline extends Component<TListInlineProps> {
  static defaultProps = {
    as: 'ul',
    defaultClassName: 'list-inline',
  };
  static Item = ListInlineItem;
  static Link = ListInlineLink;

  render(): JSX.Element {
    const {
      className,
      filteredCategory,
      filterList,
      ...otherProps
    } = this.props;

    const cx = classNames({
      'list-inline--filtered-category': filteredCategory,
      'widget-filter__list': filterList,
      [className]: !!className,
    });

    return <ProductComponent className={cx} {...otherProps} />;
  }
}

export default ListInline;
export { ListInlineItem, ListInlineLink };
